import React from "react";

import Script from "dangerous-html/react";

import "../layout/navigation.css";

const Navigation: React.FC = () => {
  return (
    <div className="navigation-container1">
      <nav id="mainNavigation" className="navigation">
        <div className="navigation-container">
          <a href="#">
            <div className="navigation-logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                className="navigation-logo-icon"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                ></path>
              </svg>
              <span className="section-title">Professional Details</span>
            </div>
          </a>
          <button
            id="mobileMenuToggle"
            aria-expanded="false"
            aria-label="Toggle navigation menu"
            className="navigation-mobile-toggle"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 5h16M4 12h16M4 19h16"
              ></path>
            </svg>
          </button>
          <div className="navigation-menu">
            <a href="#">
              <div className="navigation-link navigation-link-active">
                <span className="navigation-link-text">Home</span>
                <span className="navigation-link-indicator"></span>
              </div>
            </a>
            <a href="#services">
              <div className="navigation-link">
                <span className="navigation-link-text">Services</span>
                <span className="navigation-link-indicator"></span>
              </div>
            </a>
            <a href="#expertise">
              <div className="navigation-link">
                <span className="navigation-link-text">Expertise</span>
                <span className="navigation-link-indicator"></span>
              </div>
            </a>
            <a href="#projects">
              <div className="navigation-link">
                <span className="navigation-link-text">Projects</span>
                <span className="navigation-link-indicator"></span>
              </div>
            </a>
            <a href="#about">
              <div className="navigation-link">
                <span className="navigation-link-text">About</span>
                <span className="navigation-link-indicator"></span>
              </div>
            </a>
            <a href="#contact">
              <div className="navigation-cta btn btn-primary">
                <span>Get In Touch</span>
              </div>
            </a>
          </div>
        </div>
        <div id="mobileMenuOverlay" className="navigation-mobile-overlay">
          <div className="navigation-mobile-header">
            <a href="#">
              <div className="navigation-mobile-logo">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  className="navigation-mobile-logo-icon"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                  ></path>
                </svg>
                <span className="section-title">Portfolio</span>
              </div>
            </a>
            <button
              id="mobileMenuClose"
              aria-label="Close navigation menu"
              className="navigation-mobile-close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M18 6L6 18M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          <div className="navigation-mobile-content">
            <a href="#">
              <div className="navigation-mobile-link navigation-mobile-link-active">
                <span>
                  {" "}
                  Home
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
              </div>
            </a>
            <a href="#services">
              <div className="navigation-mobile-link">
                <span>Services</span>
              </div>
            </a>
            <a href="#expertise">
              <div className="navigation-mobile-link">
                <span>Expertise</span>
              </div>
            </a>
            <a href="#projects">
              <div className="navigation-mobile-link">
                <span>Projects</span>
              </div>
            </a>
            <a href="#about">
              <div className="navigation-mobile-link">
                <span>About</span>
              </div>
            </a>
            <a href="#contact">
              <div className="navigation-mobile-cta btn btn-primary">
                <span>
                  {" "}
                  Get In Touch
                  <span
                    dangerouslySetInnerHTML={{
                      __html: " ",
                    }}
                  />
                </span>
              </div>
            </a>
          </div>
        </div>
      </nav>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
        @keyframes slideInStagger {to {opacity: 1;
transform: translateX(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<script defer data-name="navigation-mobile-menu">
(function(){
  const mobileMenuToggle = document.getElementById("mobileMenuToggle")
  const mobileMenuClose = document.getElementById("mobileMenuClose")
  const mobileMenuOverlay = document.getElementById("mobileMenuOverlay")
  const navigation = document.getElementById("mainNavigation")

  function openMobileMenu() {
    mobileMenuOverlay.style.display = "block"
    setTimeout(() => {
      mobileMenuOverlay.classList.add("navigation-mobile-open")
    }, 10)
    mobileMenuToggle.setAttribute("aria-expanded", "true")
    document.body.style.overflow = "hidden"
  }

  function closeMobileMenu() {
    mobileMenuOverlay.classList.remove("navigation-mobile-open")
    setTimeout(() => {
      mobileMenuOverlay.style.display = "none"
    }, 500)
    mobileMenuToggle.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""
  }

  mobileMenuToggle.addEventListener("click", openMobileMenu)
  mobileMenuClose.addEventListener("click", closeMobileMenu)

  const mobileLinks = document.querySelectorAll(".navigation-mobile-link")
  mobileLinks.forEach((link) => {
    link.addEventListener("click", () => {
      if (link.getAttribute("href").startsWith("#")) {
        closeMobileMenu()
      }
    })
  })

  mobileMenuOverlay.addEventListener("click", (e) => {
    if (e.target === mobileMenuOverlay) {
      closeMobileMenu()
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
